var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tree-view-node',{staticClass:"treeView",attrs:{"nodes":_vm.value,"idPrefix":_vm.idPrefix},on:{"selected":_vm.setSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }